import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { Booking } from '../booking';

interface RejectedBookingsModalProps {
  show: boolean;
  onHide: () => void;
  rejectedDetails: Booking[];
  rejectedModalError: string | null;
  handleViewClick: (booking: Booking) => void;
  statusColors: { [key: string]: string };
}

const RejectedBookingsModal: React.FC<RejectedBookingsModalProps> = ({
  show,
  onHide,
  rejectedDetails,
  rejectedModalError,
  handleViewClick,
  statusColors,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Rejected Bookings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {rejectedModalError && <div className="alert-error">{rejectedModalError}</div>}
        {!rejectedModalError && rejectedDetails.length === 0 && (
          <div className="alert-info">No rejected bookings found.</div>
        )}
        {rejectedDetails.length > 0 && (
          <div className="table-responsive">
            <Table className="table text-nowrap">
              <thead className="table-primary">
                <tr>
                  <th>ID</th>
                  <th>Emp Num</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {rejectedDetails.map((booking, index) => (
                  <tr key={index}>
                    <td>{booking.id}</td>
                    <td>{booking.user?.empNumber || 'N/A'}</td>
                    <td>{booking.user?.name || 'N/A'}</td>
                    <td>
                      <span className={statusColors[booking.status] || 'badge bg-secondary'}>
                        {booking.status || 'N/A'}
                      </span>
                    </td>
                    <td>{booking.priority || 'N/A'}</td>
                    <td>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleViewClick(booking)}
                        title="View Booking"
                      >
                        <i className="feather-eye" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectedBookingsModal;